// extracted by mini-css-extract-plugin
export var container = "_f5-0";
export var icon = "_f5-1";
export var text = "_f5-2";